var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaystack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10860_1703",
    transform: "scale(0.00444444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10860_1703",
    width: 225,
    height: 225,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAYFBMVEX///8JpdsAodoAo9z7/v6g1u8Andh/x+jp9vu34fPU7Pe/4vMAn9nm9vum1e2b1O5Jt+Pu+Pxsw+jG5/Ziv+Y9s+IerN/Y7/mFzeyu3fI0sOGO0O7g8voAqN7t+Pza8Pk6jHdgAAACUklEQVR4nO3cbZKaQBRG4aYbEbUTRT6UUcz+dxkymbHmV0JBz3vVOs8OTgFK9wWcAwAAAAAAAAAAAAAAAAAAAAAAQDJ1MxQCWbMzCmxiyDTiIbcIPHhR38i3BoGbqAscE1f6wlYZmGWdPLBSXYMfikpdWEpP0vE0/fHqhZFCCimkkEIKKaSQwhlybWAW9WvgRru4OMgD3alQBsZaX+j2wsR4Ngh0rg8+SHiLPYx3+eayFjj3JjttAIBUciGLvr7NNH/577qzetu7atXb3mGrLWzFk4tRuCoDV8Lx4Z10DfVmEJjFUheonq795Te6wlK6AL4X/hQWin9IKaSQQgoppJBCk0LuaZ6+0A0mhco18NFicTEIA93V4DSN2glNL0+MjTTQubqLXinsxYGj7Upox4wNAJ5UVQrI37S4yy9diAJ+ONv8FZaDbDbjB+nQ6VOn6vtjMDiKe+l0zRs82CY9hCN5oHq6Fm/qQvVOFO+uUUghhRRSSCGF31IovqfhGH4D8XQtyAPdWro+DOqhzOgmXT5Fi22MWnglFsKnLr+4HqJkvBZjK37A+0vjbqNgstEGAEglP23nEr4aMt/tGBb8479Zfe5xul9h2Z1pYfMVgemWf/qj6K0b/u2SYPX02E85JZiuxYe+FKsEh9DscxeTpNiJ8gYPG06XYieKQlsUUkihPQopfILC17+nSXFf+tCFSdYWFp8KnO68/CCGx14fvv4a3538wn2atXXBf1XH2Q+y+xifYK9tlG93M9VPsV8KAAAAAAAAAAAAAAAAAAAAAEjvN8OjUsMh8ggXAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/paystack.a9c573f25d36363f75fb33f49b55aea6.svg";
export { ForwardRef as ReactComponent };